import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { Competitor } from '../types/entities/Competitor';

export const competitor: SchemaWithClient<Competitor> = {
  name: 'Competitor',
  pluralName: 'Competitor',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    website: {
      name: 'Website',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/competitors'),
};
